import { render, staticRenderFns } from "./WishlistIcon.vue?vue&type=template&id=26786298&scoped=true&"
import script from "./WishlistIcon.vue?vue&type=script&lang=js&"
export * from "./WishlistIcon.vue?vue&type=script&lang=js&"
import style0 from "./WishlistIcon.vue?vue&type=style&index=0&id=26786298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26786298",
  null
  
)

export default component.exports